import React from "react";
import axios from "axios";

const TrackApi=async(data)=>{
    const UtcDate=await new Date();
    const year=UtcDate.getUTCFullYear();
    const month=String(UtcDate.getUTCMonth() + 1).padStart(2, '0');
    const dateIs=String(UtcDate.getUTCDate()).padStart(2, '0');
    const hours=String(UtcDate.getUTCHours()).padStart(2, '0');
    const minutes=String(UtcDate.getUTCMinutes()).padStart(2, '0');
    const second=String(UtcDate.getUTCSeconds()).padStart(2, '0');
    const UtcDateTime=`${year}-${month}-${dateIs} ${hours}:${minutes}:${second}`;
    const activitybody={
        "RelatedProspectId":data.RelatedProspectId,
        "ActivityEvent": 263,
        "ActivityNote": `${data.mx_Custom_1} page visited`,
        "ProcessFilesAsync": true,
        "ActivityDateTime": UtcDateTime,
        "Fields": [
        {
        "SchemaName": "mx_Custom_1",
        "Value": data.mx_Custom_1
        },
        {
        "SchemaName": "mx_Custom_2",
        "Value": "",
        "Fields": [
            {
                "SchemaName": "mx_CustomObject_81",
                "Value": data.mx_CustomObject_81
                }
        ]
        },
       ]
        };
        //activity track user by crm api used define in one components.
    axios.post("https://www.moneysukh.com/signupUpdateLead",activitybody).then((res)=>{
}).catch((e)=>{
        console.log("activityapierror",e);
      })

    return <>
    </>
}
export default TrackApi;